<template>
  <form class="form" method="post">

    <div id="appSpendingsChoiceVueComponent">
      <HeaderApp />
      <div class="appSpendingCardCreate appFontBlack">
        <h2>Mes Dépenses</h2>
      </div>
      <div class="appFontBlack ">
        <button @click.prevent="createSpending()" type="submit" class="appButtonModel2">Ajouter une nouvelle
          dépense</button>
        <input type="text" v-model="search" class="appSearchBar" placeholder="Rechercher">
      </div>
      <div :key="index" v-for="(spending, index) in filteredSpending" class="appSpendingCardList">
        <div class="appSpendingCardListLine1">
          <p>{{ format_date(spending.date) }}</p>
          <button @click.prevent="editSpending(spending._id)" type="submit" class="appButtonModel4">Modifier</button>
        </div>
        <div class="appSpendingCardListLine1">
          <p>{{ spending.supplier }}</p>
          <p>{{ spending.price }} €</p>
        </div>
        <div class="appSpendingCardListLine2">
          <p>{{ spending.category }} {{ spending.reference }}</p>
          <p>({{ spending.typeofpaiement }})</p>
        </div>
        <div class="appSpendingCardListLine2">
        </div>

      </div>
    </div>

  </form>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import HeaderApp from '../Application/HeaderApp.vue'
export default {
  beforeCreate () {
    const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
    if (!tokenWithDatas) { this.$router.push('/App/Login') }
  },
  components: {
    HeaderApp
  },
  name: 'SpendingsList',
  data () {
    return {
      spending: '',
      search: ''
    }
  },
  computed: {
    filteredSpending () {
      if (this.spending.length > 0) {
        return this.spending.filter(spending => {
          return spending.supplier.toLowerCase().includes(this.search.toLowerCase()) ||
          spending.reference.toLowerCase().includes(this.search.toLowerCase()) ||
          spending.category.toLowerCase().includes(this.search.toLowerCase())
        })
      }
    }
  },
  mounted () {
    this.getAllSpendings()
  },
  methods: {
    format_date (value) {
      if (value) {
        return moment(String(value)).format('DD/MM/YYYY')
      }
    },
    getAllSpendings () {
      const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
      axios
        .get(('https://privilegia.fr/api/depenses'), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
        .then((response) => {
          this.spending = response.data.sort(function tri (a, b) {
            if (a.date < b.date) { return 1 }
            if (a.date === b.date) { return 0 }
            if (a.date > b.date) { return -1 }
          })
        })
    },
    createSpending () {
      this.$router.push('/App/Spendings/Create')
    },
    editSpending (id) {
      this.$router.push('/App/Spendings/Edit?id=' + id)
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Application/AppSpendingsChoice.vue